export default __webpack_public_path__ + "static/0097-b1ca0d6434f58bf566351a5beae66888.png";